import { Heart, Share2, Plus } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { onApiCallPropertySimilarList } from "../../Core/Apicall";
import { useEffect, useState } from "react";
import { UrlImage } from "../../Core/ApiEndPoint";
import { useTranslation } from "react-i18next";


export function PropertiesCard({ multiple_images, address, title, bathrooms, bedrooms, type, id, price_monthly_up, price_monthly_down }) {

    const [showShareMenu, setShowShareMenu] = useState(false);
    const navigator = useNavigate();
    const formatPrice = (value) => {
        if (!value) return "";
        return Number(value).toLocaleString("en-US");
    };
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const lang = i18n.language;

    const [loadedImages, setLoadedImages] = useState({});

    const handleImageLoad = (index) => {
        setLoadedImages((prev) => ({ ...prev, [index]: true }));
    };
    return (
        <div className="card">
            <div className="card-image-wrapper"
            >
                <Swiper
                    style={{ height: "100%", zIndex: "1" }}
                    slidesPerView={1}
                    spaceBetween={16}
                    navigation
                    pagination={{ clickable: true }}
                    loop={true}

                    autoplay={{
                        delay: 3000,   // 3 seconds
                        disableOnInteraction: false,
                    }}
                    modules={[Navigation, Pagination, Autoplay]}
                    breakpoints={{
                        640: { slidesPerView: 1 },
                        960: { slidesPerView: 1 },
                    }}
                >
                    {multiple_images && multiple_images.map((img, index) => (
                        <SwiperSlide key={index} style={{ height: "100%" }} >
                            {!loadedImages[index] && (
                                <div className="card-image-skeleton">
                                    <span className="card-image-spinner"></span>
                                </div>
                            )}
                            <img style={{ cursor: "pointer" }}
                                onClick={() => {
                                    window.location.href = `/properties/properties-details/${id}?lang=${lang}`;
                                }
                                }
                                src={UrlImage + img}
                                onLoad={() => handleImageLoad(index)}
                                loading="lazy"
                                alt={title} className="card-image" />
                        </SwiperSlide>
                    ))}

                </Swiper>


            </div>

            <div className="card-body">
                <div className="price-box">
                    {/* <span className="from">{t("from")}</span> */}
                    <span className="price">
                        {price_monthly_up ? (
                            price_monthly_down && Number(price_monthly_down) !== 0 ? (
                                `$${formatPrice(price_monthly_down)}-$${formatPrice(price_monthly_up)}`
                            ) : (
                                `$${formatPrice(price_monthly_up)}+`
                            )
                        ) : (
                            ""
                        )}</span>
                    {/* <span className="per">/ {t("month")}</span> */}
                </div>
                <div className="card-info ">
                    {address}
                </div>


                <h3 className="card-title">{title}</h3>
                <div className="card-info flex items-center gap-2 card-info-icons">
                    <span>
                        <i className="fa-solid fa-bed mr-1"></i>
                        {bedrooms} {t("Bedrooms")}
                    </span>
                    <span></span>
                    <span>
                        <i className="fa-solid fa-bath mr-1"></i>
                        {bathrooms} {t("Baths")}
                    </span>
                </div>


                <div className="card-footer">

                    <button onClick={() => navigator(`/properties/properties-details/${id}?lang=${lang}`)} >See Details</button>
                </div>
            </div>
        </div>
    );
}
export default function SimilarListings({ id }) {
    const [profileData, setProfileData] = useState([]);
    const { i18n } = useTranslation();
    const lang = i18n.language;

    const handleApiCallPropertyList = async () => {
        try {
            const data = {
                id: id
            }
            const params = `/?lang=${lang}`
            const response = await onApiCallPropertySimilarList(data, params);
            setProfileData(response.data);
        } catch (err) {
            console.error("Error fetching property list:", err);
        }
    };
    useEffect(() => {
        handleApiCallPropertyList();
    }, [lang, id]);

    const { t } = useTranslation();

    return (
        <div className="properties-page " style={{ marginTop: "60px" }} >
            <h2 className="page-title" style={{ marginBottom: "30px", color: '#295d85', fontSize: "25px", fontWeight: "700" }}>{t("Similar Listings")}</h2>

            <div className="grid">
                {profileData?.length > 0 ? (
                    profileData.map((item, i) => (
                        <PropertiesCard key={i} {...item} />
                    ))
                ) : (
                    <p>{t("No similar listings found.")}</p>
                )}
            </div>

        </div>
    );
}
